module.exports = __webpack_public_path__ + "img/set-3.bc8dc652.jpg";